import type { TFunction } from 'i18next';

/**
 * The name a search result is shown under. Mappers leave an untitled result's
 * title empty instead of inventing English copy, so every render site goes
 * through here to get the user-language fallback.
 */
export const searchResultTitle = (
  t: TFunction,
  result: { title?: string | null; type?: string | null },
): string => result.title
  || t(result.type === 'web' ? 'chat.sourceLabels.webSource' : 'chat.sourceLabels.untitledDocument');
